$shm_hitalama_quick2_reorder $shm_hitalama_quick2
	ids? /string
	gesture_moved*? false
	Panel $mol_view
		style *
			^
			width <= panel_width \
			height <= panel_height \
		sub <= buttons /
	Button* $mol_check
		checked? <=> button_checked*? false
		event *
			^
			pointerenter? <=> pointerenter*?
			pointerleave? <=> pointerleave*?
		sub /
			<= Speck*
			<= Label*
	Drag* $shm_hitalama_quick_item
		left? <=> drag_x*? 0
		top? <=> drag_y*? 0
		dragged => order_dragged*
		on_drag_start? <=> order_start*? null
		on_drag_end? <=> order_end*? null
		sub / <= Button*
